import { render, staticRenderFns } from "./line2.vue?vue&type=template&id=6b47fe40&scoped=true&"
import script from "./line2.vue?vue&type=script&lang=js&"
export * from "./line2.vue?vue&type=script&lang=js&"
import style0 from "./line2.vue?vue&type=style&index=0&id=6b47fe40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47fe40",
  null
  
)

export default component.exports